export const userStatuses = {
  REGISTERED: 'registered',
  ACTIVE: 'active'
}
export const dateFormat = 'YYYY-MM-DD'
export const dateTimeFormat = 'YYYY-MM-DD HH:mm:ss'
export const contentTypes = {
  dita: 'dita',
  webview: 'webview',
  highres: 'highres'
}
export const tagsByContentType = {
  [contentTypes.webview]: ['Webview'],
  [contentTypes.highres]: ['High Res Cover', 'High Res Inset']
}
export const contentTypeByTags = Object.entries(tagsByContentType).reduce((obj, [contentType, tags]) => {
  tags.forEach(t => {
    obj[t] = contentType
  })
  return obj
}, {})
export const allPubTypes = 'ALL_PUB_TYPES'

export const UG = 'UG' // User Guide
export const OM = 'OM' // Owner Manual
export const NM = 'NM' // Navigation
export const MM = 'MM' // Multi media
export const ORM = 'ORM' // Offroad manual
export const DFOM = 'DFOM' // Digital First Owner Manual,
export const WTY = 'WTY' // Service & Warranty or SW
export const EOM = 'EOM' // EyeSight Owner Manuals
export const CSOM = 'CSOM' // Connected Service Owner Manual

export const BRANDS = {
  TOYOTA: 'toyota',
  LEXUS: 'lexus'
}

export const PUBLICATION_TYPES = {
  VIDEO: 'VIDEO'
}

export const PUBLICATION_STATES = {
  DRAFT: 'draft',
  PUBLISHED: 'published'
}

export const TOPIC_TYPES = {
  TOPIC: 'topic',
  VIDEO: 'video'
}
